import router, { asyncRoutes, constantRoutes } from '@/router'
import { getRouters } from '@/api/menu.js'
import Layout from '@/layout'
const shabixuqiu = [
  'admin:dynamicContentLib',
  'admin:DynamicContentWordLib',
  'admin:dynamicContentTop',
  'admin:dynamicContentAutoChat'
] // 路由黑名单
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role))
  } else {
    return true
  }
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  // 生成路由
  generateRoutes({ commit }, roles) {
    return new Promise((resolve, reject) => {
      // 向后端请求路由数据
      getRouters().then((res) => {
        const sdata = JSON.parse(JSON.stringify(res))
        const sidebarRoutes = filterAsyncRouter(sdata)
        sidebarRoutes.push({ path: '*', redirect: '/404', hidden: true })
        commit('SET_ROUTES', sidebarRoutes)
        resolve(sidebarRoutes)
      })
    })
  }
}

/**
 * 按需加载路由
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRouter(routes, lastRouter = false) {
  return routes.filter((route) => {
    if (route.component) {
      if (route.component === 'Layout') {
        route.component = Layout
      }
      if (route.children && route.children.length > 0) {
        route.children.forEach((item) => {
          // 使用 import 实现生产环境的路由懒加载
          item.component = loadView(item.component)
        })
      }
    }
    return true
  })
}

export const loadView = (view) => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'staging'
  ) {
    return (resolve) => require([`@/views${view}`], resolve)
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return () => import(`@/views${view}`)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
